import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

interface IErrors {
  minlength?: string;
  maxlength?: string;
  min?: string;
  max?: string;
  email?: string;
  password?: string;
  pattern?: string;
}

@Component({
  selector: 'app-password',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent {

  @Input() public control: FormControl; /**Form control of the input */
  @Input() public group: FormGroup; /**Form group of the input */
  @Input() public placeHolder; /**Place holder of that input */
  @Input() public errorMessage: IErrors; /**Error Messages of perticular input */
  @Input() public fieldRequired = 'Field required';

  hide = true;
  public error;



  checkError() {
    if (this.control && this.control.invalid && this.control.touched) {
      this.error = this.control.invalid;
    }
  }

}
